import z from 'zod'
import {
  firestoreTimestamp,
  firestoreWriteTimestamp,
  nullSafeOptionalFirestoreTimestamp,
} from '../shared/schema'

export const schema = z.object({
  sectionId: z.string().optional(),
  assignmentId: z.string().optional(),
  roomStateId: z.string(),
  userId: z.string(),
  slideDeckId: z.string(),
  slideDeckName: z.string(),
  slideDeckImageURL: z.string(),
  slideDeckTeaser: z.string(),
  quizScore: z.number().nonnegative().nullish(),
  completionScore: z.number().nonnegative().nullish(),
  attendanceScore: z.number().nonnegative().nullish(),
  contributionScore: z.number().nonnegative().nullish(),
  totalRubricScore: z.number().nonnegative().nullish(),
  totalScore: z.number().nonnegative().nullish(),
  // Record<rubricId, score>
  rubricScores: z
    .array(
      z.object({
        rubricId: z.string(),
        rubric: z.string(),
        score: z.number().nonnegative(),
        rubricType: z.number().int(),
        slideId: z.string().nullish(),
        dataMissing: z.boolean().optional(),
        assignmentRoles: z.array(z.string()).optional(),
      })
    )
    .nullish(),
  createdAt: firestoreTimestamp,
  hasTakenQuiz: z.boolean().default(false),
  hasEngagement: z.boolean().default(false),
  updatedAt: firestoreTimestamp,
  roomStartedAt: nullSafeOptionalFirestoreTimestamp(), // Records from October 2025 and earlier will not have this field
  assignmentRole: z.string().optional(),
})

export const writeSchema = schema.extend({
  createdAt: firestoreWriteTimestamp,
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    sectionId: '',
    assignmentId: '',
    roomStateId: '',
    userId: '',
    slideDeckId: '',
    slideDeckName: '',
    slideDeckTeaser: '',
    slideDeckImageURL: '',
    quizScore: undefined,
    completionScore: undefined,
    attendanceScore: undefined,
    rubricScores: [],
    contributionScore: undefined,
    totalRubricScore: undefined,
    totalScore: undefined,
    createdAt: { seconds: 0, nanoseconds: 0 },
    updatedAt: { seconds: 0, nanoseconds: 0 },
    roomStartedAt: { seconds: 0, nanoseconds: 0 },
  })
)

type FirestoreRoomStateOutputInferred = z.infer<typeof schema>

export interface FirestoreRoomStateOutput extends FirestoreRoomStateOutputInferred {}
